import script from "./contedo-contatos.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-contatos.vue?vue&type=script&setup=true&lang=js"

import "./contedo-contatos.vue?vue&type=style&index=0&id=808bc77a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808bc77a"]])

export default __exports__